import { Component } from 'react';
import {
    Page,
    Card,
    BlockStack,
    Button,
    Text,
    Badge,
    TextField,
    Spinner,
    ProgressBar,
    Modal,
    Banner,
    Pagination,
    Icon,
    Popover,
    ActionList,
} from '@shopify/polaris';
import { withRouter } from 'react-router-dom';
import {
    reqGetAllBrokenLinks,
    reqCheckThemeAppExtension,
    reqAddBrokenLinkById,
    reqUpdAutoRedirect,
    reqPostManageLinkByIdAction,
    reqBrokenManageLinkById,
    reqBrokenIgnoerLinkById,
    reqBrokenDeleteLinkById,
    reqUpdBatchOpt,
    reqGetBatchOpt,
    reqStopBatchOpt,

} from '../../../api';
import { connect } from 'react-redux'
import { setPageData } from '../../../redux/actions/getAppPageData';
import SkeltonLoading from "../../../components/SkeltonLoading";
import { EditIcon, ExportIcon, ImportIcon, LockIcon } from "@shopify/polaris-icons";
import './index.css';
import Switch from "react-switch";
import utils from '../../../utils/utils';
import Language from '../../../i18n/Language';
import TableFilters from '../../../components/TableFilters';
import IndexTableBox from './components/IndexTableBox';
// import NewReviewModal from "../../../components/ReviewModal";
import AddRedirectActionModal from '../../../components/AddRedirectActionModal';
import ImportRedirectActionModal from '../../../components/ImportRedirectActionModal';
import ExportRedirectActionModal from '../../../components/ExportRedirectActionModal';

import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import FooterPageSelect from '../../../components/FooterPageSelect/indexPage';
import { store } from '../../../redux/store';
import FaqCardBox from '../../../components/FaqCardBox';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
import { getPathFromUrl, getNormalUrl } from '../../../utils/public_event';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import PlanLockBlock from '../../../components/PlanLockBlock';
const t = Language;

let timeArr = [];
class BrokenLinkPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true, // 列表loading
            loadingPage: true, // 页面loading

            showToast: false,  //弹窗显示
            showToastText: '',  //弹窗文字
            showToastIserror: false, //弹窗是否错误
            level: 0, // 等级
            // 表格标题
            unresolvedHeading: [
                { title: t("Missing Page") },
                { title: t("Traffic") },
                { title: t("First seen") },
                { title: t("Redirect To") },
                { title: t("Actions") },
            ],
            manageHeading: [
                { title: t("Missing Page") },
                { title: t("Traffic") },
                { title: t("Redirect To") },
                { title: t("Actions") },
            ],
            ignoredHeading: [
                { title: t("Original path") },
                { title: t("Traffic") },
                { title: t("Actions") },
            ],
            tabKey: 0, // tab 索引

            page: 1,
            size: 10,
            queryValue: '', // 搜索框val
            tableData: [], // 列表数据
            isShowCreateModa: false, // 弹窗状态
            AddRedirectActiveLoading: false, // 创建loading
            domain: '', // 域名
            targetLink: '', // 目标链接
            targetLinkState: false, // 目标链接状态
            checkState: false, // 开关状态
            switchLoading: true, // 开关loading
            saveLoading: false, // 保存目标链接loading

            pageUpgradeModal: false, // 升级状态
            IsPop: false, // 好评状态
            modalEmail: window.email, // 好评邮箱
            modalName: window.shopOwner, // 好评名称

            AddRedirectActive: false, // 单个导入状态
            ImportActive: false, // 导入状态
            ExportActive: false, // 导出状态
            upgradeModalShow: false, // 升级状态

            RedirectActive: false, // 批量重定向弹窗状态
            IgnoreActive: false, // 批量忽略弹窗状态

            showTipModalStatus: false, // 主题扩展
            themeAppExtensionUrl: '', // 跳转开启链接
            TargetValue: '', // 创建重定向输入
            RedirectActiveLoading: false, // 创建loading
            tableItemState: [0, 0], // 表格选择状态
            UnignoreActive: false, // 批量不忽略
            UnignoreActiveLoading: false,  // 不忽略状态

            isShowFixTagProgress: -1, // 是否批量操作中
            isBatchLoading: false,
            selection_status: 0,
            current_operation: 0, // 1.跳转，2.忽略。3.还原
            implement_number: 0, // 总数量
            current_implement_number: 0, // 当前优化数量
            TargetValueFocus: false, // 聚焦
            DeleteActive: false, // 批量删除状态
            DeleteActiveLoading: false, // 删除loading

            tableTabsLoading: false, // 表格loading
            current_PageSize: 10,
            total: 0, // 总数
            blHasPrevious: false,
            blHasNext: false,

            isShowPanel: false,
            suggestionArr: [
                '/',
                '/collections/all',
            ],
            isOnce: 0, // 是否重新请求多一次的数量
            optType: -1, // 优化类型
            isShowCreateTip: false,
            createTip: '',
            isEmbeddedModa: false,   // 是否内嵌

            questionList: {
                w_blink: {
                    title: "What are broken links?",
                    tag: ["Broken links refer to links on a webpage that point to target pages that no longer exist or cannot be accessed. This may be because the target page has been deleted, moved, changed its URL, or temporarily unavailable."]
                },
                hd_blink: {
                    title: "How to discover broken links on a website and fix them?",
                    tag: ["SEOWILL continuously and automatically detects 404 links on your website 24/7. You can repair the discovered 404 links in the list to restore their normal functionality."]
                },
                hta_blink: {
                    title: "How to avoid broken links?",
                    tag: ["Activate SEOWILL's automatic redirection feature. When SEOWILL detects 404 links, it will automatically repair them and promptly redirect to recover user engagement."]
                },
                wid_blink: {
                    title: "What impact do broken links have on SEO?",
                    tag: ["Broken links may have a negative impact on a website's search engine ranking. Search engines consider the quality of a website's links and user experience, and broken links may be viewed as low-quality content, affecting the website's credibility and ranking."]
                },
                waf_blink: {
                    title: "What effects do broken links have on a website?",
                    tag: ["Broken links may affect user experience and a website's search engine ranking. For users, broken links lead to loading errors or 404 errors, diminishing the user experience. For search engines, broken links may decrease a website's credibility and impact its ranking."]
                },
                war_blink: {
                    title: "Why are my normal links appearing as 404 links? If redirected, will it redirect my links incorrectly?",
                    tag: ["This situation occurs because, at the time of our initial detection, the link was a 404 link. Later, when the link was updated to a normal link, we were unable to detect the change. However, this does not matter because Shopify does not redirect good links, so it will not affect your website. Of course, you can also manually ignore and delete these links."]
                }
            },
            isShowEditLink: false,
            actionState: false,
            targetLinkEdit: "",
            stopBatchOptLoading: false,
        };

        // 防抖节流
        this.debounceGetBrokenlink = debounce(this.getBrokenlinkList, 500);
    }

    componentDidMount() {
        let _page = store.getState().page;
        this.getBatchOpt();
        this.getBrokenlinkList('', _page.pageInit?.Brokenlinks);
        if (this.state.tabKey === 0) {
            this.checkThemeExtension();
        }
    }

    componentWillUnmount() {
        this.delTimerArray();
        this.setState = () => false
    }

    // 升级弹窗
    upgradeShow = () => {
        this.props.upgradeModal(1, '404', '404');
    }

    // 获取批量操作数据
    getBatchOpt = async (keys = 0) => {
        let { tabKey, isOnce, checkState } = this.state;
        let getKey = keys !== 0 ? keys : (tabKey === 2 ? 3 : tabKey);
        const res = await reqGetBatchOpt({ status: getKey });
        if (res.ack === 1) {
            if (res.data.isBatchLoading) {
                this.setState({
                    isShowFixTagProgress: res.data.selection_status,
                    current_implement_number: res.data.current_implement_number,
                    implement_number: res.data.implement_number,
                    current_operation: res.data.current_operation,
                    optType: res.data.opt
                }, () => {
                    if (timeArr.length === 0) {
                        let timer = setInterval(() => {
                            this.getBatchOpt();
                        }, 5000)
                        timeArr.push(timer)
                    }
                })
            } else {
                if (res.data.is_pop === 1) {
                    let objs = res.data.current_operation === 1 ? 'redirected' : res.data.current_operation === 2 ? 'ignored' : 'unignored';
                    if (tabKey === 0) {
                        this.props.toggleToast(`${res.data.current_implement_number} 404 links ${objs}`, false);
                    } else if (tabKey === 1) {
                        this.props.toggleToast(`${res.data.current_implement_number} manage links ${objs}`, false);
                    } else {
                        this.props.toggleToast(`${res.data.current_implement_number} 404 links ${objs}`, false);
                    }

                    // 操作后重新请求一次确定是否存在自动轮询
                    if (isOnce === 0 && res.data.opt === 0 && Boolean(checkState)) {
                        setTimeout(() => {
                            this.setState({
                                isOnce: 1,
                            }, () => {
                                this.getBatchOpt();
                            })
                        }, 500)
                    }
                    this.getBrokenlinkList();
                }
                this.setState({
                    isShowFixTagProgress: -1,
                    current_implement_number: 0,
                    implement_number: 0,
                    optType: res.data.opt
                }, () => {
                    this.delTimerArray();
                })
            }

        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取主题扩展状态
    checkThemeExtension = async () => {
        const res = await reqCheckThemeAppExtension({})
        if (res.code === 200) {
            this.setState({
                themeAppExtensionUrl: res.data.url,
                showTipModalStatus: !Boolean(res.data.status),
            })
        }
    }

    // 获取列表
    getBrokenlinkList = (val = '', cache = null) => {
        this.setState({
            loading: true,
        }, async () => {
            let { page, size, queryValue, tabKey } = this.state;
            const params = {
                page,
                size,
                q: Boolean(val) ? val : queryValue,
                type: `${tabKey === 2 ? 3 : tabKey}`
            };
            let res = cache || (await reqGetAllBrokenLinks(params));
            this.props.getPageDataRedux(res);
            if (res.ack === 1) {
                let t = res.data;
                let list = cloneDeep(t.lest);
                if (tabKey === 0 || tabKey === 1) {
                    list.forEach(item => {
                        item['saveState'] = false;
                        item['disabled'] = false;
                        item['saveBtnLoading'] = false;
                        item['ignoreBtnLoading'] = false;
                        item['redBtnLoading'] = false;
                        item['delBtnLoading'] = false;
                        item['errorTip'] = '';
                    })
                }
                if (Math.ceil(t.count / size) > page) {
                    this.setState({
                        blHasPrevious: page > 1 ? true : false,
                        blHasNext: true,
                    })
                } else if (Math.ceil(t.count / size) === page) {
                    this.setState({
                        blHasPrevious: page > 1 ? true : false,
                        blHasNext: false,
                    })
                } else { }


                this.setState({
                    loading: false,
                    loadingPage: false,
                    stopBatchOptLoading: false,

                    tableData: list,
                    total: t.count, // 总数
                    domain: t.shopurl, // 域名
                    targetLink: t.auto_redirect_url || '', // 目标链接
                    targetLinkEdit: t.auto_redirect_url || '', // 目标链接
                    checkState: Boolean(t.auto_redirect_status), // 开关状态
                    switchLoading: cache || false, // 开关loading
                    IsPop: t.IsPop, // 好评状态
                    level: t.level,
                    tableTabsLoading: cache || false, // 表格loading
                }, () => {
                    if (cache) {
                        this.getBrokenlinkList();
                    }
                })
            }
        })
    }

    // 顶部目标链接
    handleTargetChange = (val) => {
        this.handleChangeValue("targetLinkEdit", val);
        this.setState({
            targetLinkState: true
        })
    }

    // 切换tab
    handleTypeTabsChange = (i) => {
        this.setState({
            page: 1,
            size: 10,
            total: 0,
            current_PageSize: 10,
            tableTabsLoading: true, // 表格loading
            startNum: 0,
            endNum: 0,
            blHasPrevious: false,
            blHasNext: false,
            tabKey: i,
            tableData: [],
            showTipModalStatus: false,
            themeAppExtensionUrl: '',
            isShowFixTagProgress: -1,
            queryValue: '',
        }, () => {
            this.delTimerArray();
            this.getBrokenlinkList();
            this.getBatchOpt(i);
        })
    }

    // 去除定时器
    delTimerArray = () => {
        timeArr.map(timer => {
            clearInterval(timer);
            timeArr.pop();
            return false;
        })
    }

    // 搜索
    setQueryValue = (val) => {
        this.setState({
            queryValue: val,
            page: 1,
            size: 10,
            total: 0,
            current_PageSize: 10,
        }, () => {
            // this.getBrokenlinkList(val);
            this.debounceGetBrokenlink(val);
        })
    }

    // 打开创建重定向弹窗
    operaCreateModal = (state) => {
        this.setState({
            isShowCreateModa: state,
        })
    }

    // 创建重定向输入
    handleChangeValue = (field, value) => {
        // if (field === "AddPathValue") {
        //     value = "/" + this.parseUrlValue(value);
        //     if (value) {
        //         value = "/" + value.replace("/", "");
        //     }
        //     if (value.lastIndexOf('https://') >= 0 || value.lastIndexOf('http://') >= 0) {
        //         value = value.replace(/\/\//g, "/");
        //         value = value.replace(/http:\//g, "http://");
        //         value = value.replace(/https:\//g, "https://");
        //     } else {
        //         value = value.replace(/\/\//g, "/");
        //     }
        // } else {
        //     var domainValue = this.domainValueJudge(value);
        //     if (domainValue === 0) {
        //         if (value) {
        //             value = "/" + value.replace("/", "");
        //         }
        //         value = value.replace(/\/\//g, "/");
        //     }
        // }
        // this.setState({
        //     [field]: value
        // });

        let isDel = true;
        if (value && value[value.length - 1] === "/") {
            isDel = false;
        }
        this.setState({
            pathEmptyTip: false,
            targetEmptyTip: false,
        })
        value = field === "AddPathValue" ? getPathFromUrl(value) : getNormalUrl(value);
        // 最后格式
        if (value.indexOf('https://') === -1 && value.indexOf('http://') === -1) {
            value = value.replace(/\/{2,}/g, "/")      // 多斜杠合并
        }
        value = isDel ? value.replace(/\/$/, "") : value;  // 是否去掉尾部斜杠
        this.setState({
            [field]: value || "/"
        });
    };

    //判断是否有域名进行判断是否需要加斜杆  有域名返回1  没域名返回0
    domainValueJudge = (value) => {
        var parseUrlRes = this.parseUrl(value);
        if (parseUrlRes.host !== null && parseUrlRes.protocol !== null) {
            return 1
        } else {
            return 0
        }
    }

    //重新组织
    parseUrlValue = (value) => {
        if (value.lastIndexOf('https://') === 0 || value.lastIndexOf('http://') === 0) {
            var parseUrlRes = this.parseUrl(value);
            if (parseUrlRes.host !== null && parseUrlRes.protocol !== null) {
                if (parseUrlRes.path !== null) {
                    value = parseUrlRes.path
                } else {
                    value = ""
                }
            }
        }
        return value
    }

    //域名拆分
    parseUrl = (url) => {
        let urlObj = {
            protocol: /^(.+):\/\//,
            host: /:\/\/(.+?)[?#\s/]/,
            path: /\w(\/.*?)[?#\s]/,
            query: /\?(.+?)[#/\s]/,
            hash: /#(\w+)\s$/
        }
        url += ' '
        function formatQuery(str) {
            return str.split('&').reduce((a, b) => {
                let arr = b.split('=')
                a[arr[0]] = arr[1]
                return a
            }, {})
        }
        for (let key in urlObj) {
            let pattern = urlObj[key]
            urlObj[key] = key === 'query' ? (pattern.exec(url) && formatQuery(pattern.exec(url)[1])) : (pattern.exec(url) && pattern.exec(url)[1])
        }
        return urlObj
    }

    // 提交创建
    handleChangeAddRedirectSave = async () => {
        let { AddPathValue, AddTargetValue, opreState } = this.state;
        if (AddPathValue === "") {
            this.props.toggleToast("Path cannot be empty", true);
            return "";
        }

        if (AddTargetValue === "") {
            this.props.toggleToast("Target cannot be empty", true);
            return "";
        }
        if (opreState === 1) {
            this.props.toggleToast("Please try again later", true);
            return "";
        }
        this.setState({
            AddRedirectActiveLoading: true,
            opreState: 1
        });

        //调用修改接口
        const params = {
            frlink: AddPathValue,
            tolink: AddTargetValue
        };
        const response = await reqAddBrokenLinkById(params);

        if (response.code === 200) {
            //关闭请求状态
            this.setState({
                opreState: 0,
                AddRedirectActiveLoading: false,
                AddPathValue: "",
                AddTargetValue: "",
                isShowCreateModa: false,
            }, () => {
                this.props.toggleToast(response.msg, false);
                this.getBrokenlinkList();
            });
        } else {
            //关闭请求状态
            this.setState({
                opreState: 0,
                AddRedirectActiveLoading: false,
                isShowCreateTip: true,
                createTip: response.msg
            }, () => {
                // this.props.toggleToast(response.msg, true);
            });
        }

    };

    // 改变输入数据
    setChangeInputVal = (val, obj) => {
        let { tableData } = this.state;
        let data = cloneDeep(tableData);
        data.forEach(item => {
            if (item.id === obj.id) {
                item['to_link'] = val ? this.handleFormatLink(val) : '';
                item['saveState'] = true;
                item['disabled'] = false;
                item['errorTip'] = '';
            }
        })

        this.setState({
            tableData: data
        })
    }

    // 格式化
    handleFormatLink = (value) => {
        let val = "";
        if (value.indexOf('http:') > -1 || value.indexOf('https:') > -1) {
            if (value[0] === '/') {
                val = value.replace("/", '');
            } else {
                val = value;
            }
        } else {
            val = value.startsWith('/') ? value : `/${value}`;
        }
        const isFullUrl = /^https?:\/\//i.test(val);
        if (isFullUrl) {
            return val; // 保留完整的 URL，不做替换
        }
        val = val.replace(/\/{2,}/g, '/');
        return val;
    }

    // 开关-自动重定向状态
    updAutoRedirectState = (type) => {
        if (type === 'switch' && this.state.level === 1) {
            this.upgradeShow();
        } else {
            this.setState(
                type === 'switch' ?
                    {
                        switchLoading: true,
                        checkState: !this.state.checkState,
                    } : {
                        saveLoading: true,
                    }, async () => {
                        let { targetLinkEdit, checkState } = this.state;
                        let params = {
                            auto_redirect_status: Number(Boolean(checkState)),
                            auto_redirect_url: targetLinkEdit,
                        }
                        const res = await reqUpdAutoRedirect(params);
                        if (res.ack === 1) {
                            this.setState(type === 'switch' ? {
                                targetLinkState: false,
                                switchLoading: false,
                            } : {
                                targetLinkState: false, // 目标链接状态
                                saveLoading: false,
                                targetLink: targetLinkEdit,
                                isShowEditLink: false,
                            }, () => {
                                this.getBatchOpt();
                            })

                            this.props.toggleToast(res.msg, false);
                        } else {
                            this.setState(type === 'switch' ? {
                                targetLinkState: true,
                                switchLoading: false,
                                checkState: !Boolean(checkState)
                            } : {
                                targetLinkState: false, // 目标链接状态
                                saveLoading: false,
                            })
                            this.props.toggleToast(res.msg, true);
                        }
                    })
        }
    }

    // 点击保存
    onBlurUpdateSeo = (obj) => {
        let data = cloneDeep(this.state.tableData);
        data.forEach(item => {
            if (item.id === obj.id) {
                item['saveBtnLoading'] = true;
            }
            item['disabled'] = true;
        })
        this.setState({
            tableData: data,
            loading: true,
        }, async () => {
            const params = {
                id: obj.id,
                toLink: obj.to_link
            };
            const res = await reqPostManageLinkByIdAction(params);
            if (res.ack === 1 && res.code === 200) {
                this.getBrokenlinkList();
                this.props.toggleToast(res.msg, false);
            } else {
                data.forEach(item => {
                    item['saveBtnLoading'] = false;
                    item['disabled'] = false;
                    if (item.id === obj.id && res.code !== '1000') {
                        item['errorTip'] = res.msg;
                    }
                })
                this.setState({
                    loading: false,
                    tableData: data
                }, () => {
                    if (res.code === '1000') {
                        this.upgradeShow();
                        // this.setState({
                        //     pageUpgradeModal: true
                        // });
                        // } else {
                        // this.props.toggleToast(res.msg, true);
                    }
                })
            }
        })
    };

    // 点击忽略 | 还原
    updateTableIgnore = (obj, type = 'ignore') => {
        if (this.state.opreState === 1) {
            this.props.toggleToast(t("Please try again later"), true);
            return ''
        } else {
            let data = cloneDeep(this.state.tableData);
            data.forEach(item => {
                if (item.id === obj.id) {
                    if (type === 'ignore') {
                        item['ignoreBtnLoading'] = true;
                    } else {
                        item['redBtnLoading'] = true;
                    }
                }
                item['disabled'] = true;
            })
            this.setState({
                opreState: 1,
                tableData: data,
                loading: true,
            }, async () => {
                // 调用修改接口
                const params = { pageId: obj.id };
                let response = {};
                if (type === 'ignore') {
                    response = await reqBrokenManageLinkById(params);
                } else {
                    response = await reqBrokenIgnoerLinkById(params);
                }
                // 关闭请求状态
                this.setState({
                    opreState: 0
                });
                if (response.code === '200') {
                    // 重新调用数据
                    this.getBrokenlinkList();
                    this.props.toggleToast(response.msg, false);
                } else {
                    data.forEach(item => {
                        if (type === 'ignore') {
                            item['ignoreBtnLoading'] = false;
                        } else {
                            item['redBtnLoading'] = false;
                        }
                        item['disabled'] = false;
                    })
                    this.setState({
                        loading: false,
                        tableData: data
                    }, () => {
                        if (response.code === '1000') {
                            // this.setState({ pageUpgradeModal: true });
                            this.upgradeShow();
                        } else {
                            this.props.toggleToast(response.msg, true);
                        }
                    })
                }
            });
        }
    }

    //删除数据库链接
    deleteBrokenLink = async (obj) => {
        if (this.state.opreState === 1) {
            this.props.toggleToast(t("Please try again later"), true);
            return ''
        } else {
            let data = cloneDeep(this.state.tableData);
            data.forEach(item => {
                if (item.id === obj.id) {
                    item['delBtnLoading'] = true;
                }
                item['disabled'] = true;
            })
            this.setState({
                opreState: 1,
                tableData: data,
                loading: true,
            }, async () => {
                //调用修改接口
                const params = { pageId: obj.id };
                const response = await reqBrokenDeleteLinkById(params)
                //关闭请求状态
                this.setState({
                    opreState: 0
                });
                if (response.code === '200') {
                    // 重新调用数据
                    this.getBrokenlinkList();
                    this.props.toggleToast(response.msg, false);
                } else {
                    data.forEach(item => {
                        item['delBtnLoading'] = false;
                        item['disabled'] = false;
                    })
                    this.setState({
                        loading: false,
                        tableData: data
                    }, () => {
                        if (response.code === '1000') {
                            // this.setState({ pageUpgradeModal: true });
                            this.upgradeShow();
                        } else {
                            this.props.toggleToast(response.msg, true);
                        }
                    })
                }
            });
        }
    }

    // 提交
    ChildrenReRequest = () => { }

    //关闭添加单个窗口
    handleChangeAddRedirect = () => {
        this.setState({
            AddRedirectActive: false
        });
    };

    // 关闭升级弹窗
    closeUpgradeModelV2 = (val) => {
        this.setState({
            upgradeModalShow: val,
        })
    }

    // 切换tipModal弹窗状态
    toggleTipModalActive = (value) => {
        this.setState({
            showTipModalStatus: value,
        })
    }

    //批量提交输入框
    handleChangeRedirectValue = value => {
        var domainValue = this.domainValueJudge(value);
        if (domainValue === 0) {
            if (value) {
                value = "/" + value.replace("/", "");
            }
            value = value.replace(/\/\//g, "/");
        }

        this.setState({
            TargetValue: value,
            targetValError: '',
        });
    };

    // 表格选择数量状态
    getTableItemState = (val) => {
        this.setState({
            tableItemState: val
        })
    }

    // 确认批量重定向
    handleChangeRedirectSave = () => {
        let { tableItemState, TargetValue, tabKey, level, queryValue } = this.state;
        //等级等于0时弹窗
        if (level === 0) {
            this.setState({
                RedirectActive: false,
                pageUpgradeModal: true
            });
        } else if (!Boolean(TargetValue)) {
            this.setState({
                TargetValueFocus: true,
                targetValError: 'The input cannot be empty!'
            })
            // this.props.toggleToast('The input cannot be empty', true);
        } else {
            this.setState({
                RedirectActiveLoading: true,
            }, async () => {
                let params = {
                    current_operation: 1,
                    is_all: Number(tableItemState[1]),
                    status: tabKey === 2 ? 3 : tabKey,
                    ids: tableItemState[1] ? [] : tableItemState[0],
                    TargetValue,
                    query: queryValue,
                }
                const res = await reqUpdBatchOpt(params);
                if (res.ack === 1) {
                    this.props.toggleToast(res.msg, false);
                    this.setState({
                        RedirectActive: false,
                        RedirectActiveLoading: false,
                        isShowFixTagProgress: 0,
                        isBatchLoading: res.data.isBatchLoading,
                        selection_status: res.data.selection_status,
                        implement_number: res.data.implement_number,
                        current_implement_number: res.data.current_implement_number,
                        current_operation: res.data.current_operation,
                    }, () => {
                        this.getBrokenlinkList();
                        this.getBatchOpt();
                    })
                } else {
                    this.setState({
                        RedirectActiveLoading: false,
                    })
                    this.props.toggleToast(res.msg, true);
                }
            })
        }
    }

    // 批量忽略
    handleChangeIgnoreSave = () => {
        let { tableItemState, tabKey, queryValue } = this.state;
        this.setState({
            IgnoreActiveLoading: true,
        }, async () => {
            let params = {
                current_operation: 2,
                is_all: Number(tableItemState[1]),
                status: tabKey === 2 ? 3 : tabKey,
                ids: tableItemState[1] ? [] : tableItemState[0],
                TargetValue: '',
                query: queryValue,
            }
            const res = await reqUpdBatchOpt(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                this.setState({
                    IgnoreActiveLoading: false,
                    IgnoreActive: false,
                }, () => {
                    this.getBrokenlinkList();
                    this.getBatchOpt();
                })
            } else {
                this.props.toggleToast(res.msg, true);
                this.setState({
                    IgnoreActiveLoading: false,
                })
            }
        })
    }

    // 批量不忽略
    handleChangeUnignoreSave = () => {
        let { tableItemState, tabKey, queryValue } = this.state;
        this.setState({
            UnignoreActiveLoading: true,
        }, async () => {
            let params = {
                current_operation: 3,
                is_all: Number(tableItemState[1]),
                status: tabKey === 2 ? 3 : tabKey,
                ids: tableItemState[1] ? [] : tableItemState[0],
                TargetValue: '',
                query: queryValue,
            }
            const res = await reqUpdBatchOpt(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                this.setState({
                    UnignoreActiveLoading: false,
                    UnignoreActive: false,
                }, () => {
                    this.getBrokenlinkList();
                })
            } else {
                this.props.toggleToast(res.msg, true);
                this.setState({
                    UnignoreActiveLoading: false,
                })
            }
        })
    }

    // 批量删除
    handleDeleteBatch = () => {
        let { tableItemState, tabKey, queryValue } = this.state;
        this.setState({
            DeleteActiveLoading: true,
        }, async () => {
            let params = {
                current_operation: 4,
                is_all: Number(tableItemState[1]),
                status: tabKey === 2 ? 3 : tabKey,
                ids: tableItemState[1] ? [] : tableItemState[0],
                TargetValue: '',
                query: queryValue,
            }
            const res = await reqUpdBatchOpt(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                this.setState({
                    DeleteActive: false,
                    DeleteActiveLoading: false,
                }, () => {
                    this.getBrokenlinkList();
                })
            } else {
                this.props.toggleToast(res.msg, true);
                this.setState({
                    DeleteActiveLoading: false,
                })
            }
        })

    }

    // 改变页面条数
    changePageSizeData = (s) => {
        this.setState({
            page: 1,
            size: Number(s),
            current_PageSize: Number(s),
            tableTabsLoading: true,
        }, () => {
            this.getBrokenlinkList();
        })
    }

    // 历史表格 失去焦点
    handlePageBlur = (e) => {
        this.setState({
            page: Number(e),
            tableTabsLoading: true,
        }, () => {
            this.getBrokenlinkList();
        })
    }

    // 分页
    changeTablePage = (page) => {
        this.setState({
            page: Number(page),
            tableTabsLoading: true,
        }, () => {
            this.getBrokenlinkList();
        })
    }

    // 操作各个对象状态
    handleObjState = (name, state) => {
        this.setState({
            [name]: state,
            actionState: false,
        }, () => {
            if (name === 'RedirectActive') {
                this.setState({
                    targetValError: ''
                })
            }
        })
    }

    // 打开选择
    openSelectPath = () => {
        this.setState({
            isShowPanel: true
        })
    }
    closeSelectPath = () => {
        if (!this.state.isOnPanel) {
            this.setState({
                isShowPanel: false
            })
        }
    }

    // 选择
    changePathInfo = (val, type) => {
        if (type === 'click') {
            this.setState({
                isShowPanel: false,
                isOnPanel: false,
                isPathWarnTip: false,
                targetLinkState: true
            }, () => {
                this.handleChangeValue("targetLinkEdit", val);
            })
        } else if (type === 'mouse') {
            this.setState({
                isOnPanel: true
            })
        } else if (type === 'leave') {
            this.setState({
                isOnPanel: false
            })
        } else { }
    }

    // 停止批量操作
    stopBatchOpt = (type = 0) => {
        this.setState({
            stopBatchOptLoading: true,
        }, async () => {
            const res = await reqStopBatchOpt({ status: type });
            if (res) {
                this.getBatchOpt();
                this.getBrokenlinkList();
            }
        })
    }

    // 返回
    goBack = () => {
        utils.routeJump(this, '/backlinks')
    }

    //点击联系客服
    handleContactService = () => {
        try {
            showNewMessage();
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    closeChooseBanner = () => {
        let data = cloneDeep(this.state.tableItemState);
        data[1] = 0;
        this.setState({
            tableItemState: data,
        })
    }

    // 升级弹窗
    openUpgradeModal = () => {
        this.setState({
            ImportActive: false,
            ExportActive: false,
        }, () => {
            this.upgradeShow();
        })
    }

    // 关闭
    closeEditModal = () => {
        this.setState({
            isShowEditLink: false,
            targetLinkEdit: this.state.targetLink
        })
    }

    // 打开编辑
    openTargetEdit = () => {
        this.setState({
            isShowEditLink: true,
        })
    }

    // 打开关闭
    toggleActions = () => {
        let { level } = this.state;
        if (level === 1) {
            this.upgradeShow();
            return;
        }
        this.setState({
            actionState: !this.state.actionState,
        })
    }


    render() {
        const {
            state: {
                loading,
                loadingPage,
                queryValue,
                page,
                size,
                unresolvedHeading,
                manageHeading,
                ignoredHeading,
                tabKey,
                tableData,
                isShowCreateModa,
                AddRedirectActiveLoading,
                AddPathValue,
                AddTargetValue,
                domain,
                targetLink,
                targetLinkState,
                checkState,
                switchLoading,
                saveLoading,
                // pageUpgradeModal,
                IsPop,
                modalEmail,
                modalName,
                AddRedirectActive,
                ImportActive,
                ExportActive,
                // upgradeModalShow,
                RedirectActive,
                IgnoreActive,
                IgnoreActiveLoading,
                current_operation,
                implement_number,
                current_implement_number,
                showTipModalStatus,
                themeAppExtensionUrl,
                TargetValue,
                RedirectActiveLoading,
                tableItemState,
                total,
                isShowFixTagProgress,
                UnignoreActive,
                UnignoreActiveLoading,
                TargetValueFocus,
                DeleteActive,
                DeleteActiveLoading,
                current_PageSize,
                tableTabsLoading,
                blHasPrevious,
                blHasNext,
                isShowPanel,
                optType,
                isShowCreateTip,
                createTip,
                // isEmbeddedModa,
                targetValError,
                questionList,
                isShowEditLink,
                actionState,
                targetLinkEdit,
                level,
                stopBatchOptLoading,

            },
            changePathInfo,

        } = this;

        // 编辑目标链接弹窗
        const targetEditModal = <Modal
            open={isShowEditLink}
            title={t("Edit the target link")}
            primaryAction={{
                content: t("Save"),
                onAction: () => this.updAutoRedirectState('btn'),
                loading: switchLoading || saveLoading,
                disabled: !targetLinkState || !Boolean(targetLinkEdit)
            }}
            secondaryActions={[
                {
                    content: t("Cancel"),
                    onAction: this.closeEditModal
                }
            ]}
            onClose={this.closeEditModal}
        >
            <Modal.Section>
                <div className='target_link_field'>
                    <Popover
                        active={isShowPanel}
                        activator={
                            <TextField
                                label={t("Target link")}
                                value={targetLinkEdit}
                                onChange={this.handleTargetChange}
                                autoComplete="off"
                                placeholder={t("Target link")}
                                width={200}
                                disabled={checkState || switchLoading || saveLoading}
                                onFocus={this.openSelectPath}
                            />
                        }
                        autofocusTarget="none"
                        preferredAlignment='left'
                        onClose={this.closeSelectPath}
                    >
                        <ActionList
                            actionRole="menuitem"
                            items={[{
                                content: '/',
                                onAction: () => changePathInfo('/', 'click')
                            }, {
                                content: '/collections/all',
                                onAction: () => changePathInfo('/collections/all', 'click')
                            }]}
                        />
                    </Popover>
                </div>
            </Modal.Section>
        </Modal>

        // 表格批量操作选项
        const promotedBulkActions = tabKey === 2 ? [
            {
                content: t("Unignore"),
                onAction: () => this.handleObjState('UnignoreActive', true),
                disabled: isShowFixTagProgress !== -1 && isShowFixTagProgress === tabKey,
            },
            {
                content: t("Delete"),
                onAction: () => this.handleObjState('DeleteActive', true),
                disabled: isShowFixTagProgress !== -1 && isShowFixTagProgress === tabKey,
            },
        ] : [
            {
                content: t("Redirect"),
                onAction: () => this.handleObjState('RedirectActive', true),
                disabled: isShowFixTagProgress !== -1 && isShowFixTagProgress === tabKey,
            },
            {
                content: t("Ignore"),
                onAction: () => this.handleObjState('IgnoreActive', true),
                disabled: isShowFixTagProgress !== -1 && isShowFixTagProgress === tabKey,
            },
        ];

        // 创建重定向弹窗
        const createModal = <Modal
            open={isShowCreateModa}
            onClose={() => this.operaCreateModal(false)}
            title={t("Create a Redirect")}
            primaryAction={[
                {
                    content: t("Save"),
                    onAction: this.handleChangeAddRedirectSave,
                    loading: AddRedirectActiveLoading,
                    disabled: !Boolean(AddPathValue) || !Boolean(AddTargetValue)
                }
            ]}
        >
            <Modal.Section>
                <BlockStack gap={200}>
                    {
                        isShowCreateTip && <Banner
                            title={createTip}
                            tone='critical'
                            onDismiss={() => {
                                this.setState({ isShowCreateTip: false })
                            }}
                            action={{
                                content: t("Contact us"),
                                onAction: this.handleContactService
                            }}
                        >
                        </Banner>
                    }
                    <TextField
                        label={t("Path")}
                        value={AddPathValue}
                        onChange={(val) => this.handleChangeValue("AddPathValue", val)}
                        prefix={domain}
                        placeholder="e.g. /broken-link"
                    />
                    <TextField
                        label={t("Target")}
                        value={AddTargetValue}
                        onChange={(val) => this.handleChangeValue("AddTargetValue", val)}
                        placeholder='("/" = homepage url ) e.g. /collections'
                    />
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 选择所有提示
        const allChooseTip = <Banner
            title={t("You chosen all URLs in current conditions")}
            tone="warning"
            onDismiss={() => this.closeChooseBanner()}
            action={{
                content: t("Contact us"),
                onAction: this.handleContactService
            }}
        >
        </Banner>

        // 批量重定向弹窗
        const bulkRedirectModal = <Modal
            open={RedirectActive}
            onClose={() => this.handleObjState('RedirectActive', false)}
            title={t("Bulk Redirect 404 Errors")}
            primaryAction={{
                content: t("Redirect now"),
                onAction: this.handleChangeRedirectSave,
                loading: RedirectActiveLoading
            }}
        >
            <Modal.Section>
                <BlockStack gap={400}>
                    {tableItemState[1] && allChooseTip}
                    <Text as="p" fontWeight="medium">{t("When you click the \"Redirect Now\" button, SEOWILL will redirect selected 404 links to the target link you set.")}</Text>
                    <TextField
                        id="TargetValue"
                        label={t("Target link")}
                        value={TargetValue}
                        onChange={this.handleChangeRedirectValue}
                        placeholder='e.g. /shop/shoes "/" for homepage'
                        focused={TargetValueFocus}
                        error={targetValError}
                    />
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 批量忽略
        const bulkIgnoreModal = <Modal
            open={IgnoreActive}
            onClose={() => this.handleObjState('IgnoreActive', false)}
            title={t("Ignore selected items in bulk")}
            secondaryActions={[
                {
                    content: "Yes",
                    onAction: this.handleChangeIgnoreSave,
                    loading: IgnoreActiveLoading
                }
            ]}
        >
            <Modal.Section>
                <BlockStack gap={400}>
                    {tableItemState[1] && allChooseTip}
                    <p>{t("Are you sure you want to ignore the selected items?")}</p>
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 批量不忽略
        const unignoreModal = <Modal
            open={UnignoreActive}
            onClose={() => this.handleObjState('UnignoreActive', false)}
            title={t("Unignore selected items in bulk")}
            secondaryActions={[
                {
                    content: "Yes",
                    onAction: this.handleChangeUnignoreSave,
                    loading: UnignoreActiveLoading
                }
            ]}
        >
            <Modal.Section>
                {tableItemState[1] && allChooseTip}
                <p>{t("Are you sure you want to unignore the selected items?")}</p>
            </Modal.Section>
        </Modal>

        // 批量删除
        const deleteModal = <Modal
            open={DeleteActive}
            onClose={() => this.handleObjState('DeleteActive', false)}
            title="Bulk Delete"
            secondaryActions={[
                {
                    content: "Yes",
                    onAction: this.handleDeleteBatch,
                    loading: DeleteActiveLoading
                }
            ]}
        >
            <Modal.Section>
                {tableItemState[1] && allChooseTip}
                <p>{t("Are you sure you want to delete the selected items?")}</p>
            </Modal.Section>
        </Modal>

        /** 主题应用扩展提示框 */
        // const tipModal = tabKey === 0 ? <Modal
        //     size="small"
        //     open={showTipModalStatus}
        //     title={t("Tip")}
        //     onClose={() => this.toggleTipModalActive(false)}
        // >
        //     <Modal.Section>
        //         <p>{t("Before using this function, please enable the APP embed block,")}&nbsp;<Link url={themeAppExtensionUrl} external={true} onClick={() => this.toggleTipModalActive(false)}>{t("Click here")}</Link>&nbsp;{t("to open it.")}</p>
        //     </Modal.Section>
        // </Modal> : null;

        const tipBannerPwd = tabKey === 0 && showTipModalStatus ? <div style={{ marginBottom: '1rem' }}>
            <Banner
                title={t("Tip")}
                tone='warning'
                onDismiss={() => this.toggleTipModalActive(false)}
            >
                <p>{t("Before using this function, please enable the APP embed block,")}&nbsp;
                    <Button variant='plain' onClick={() => {
                        window.open(themeAppExtensionUrl);
                        this.toggleTipModalActive(false)
                    }}>
                        {t("Click here")}
                    </Button>
                    &nbsp;{t("to open it.")}
                </p>
            </Banner>
        </div> : null;

        // 分页
        const footerContentText = <FooterPageSelect
            page={page}
            current_PageSize={current_PageSize}
            total={total}
            changePageSize={this.changePageSizeData}
            handlePageBlur={this.handlePageBlur}
            tableLoading={tableTabsLoading}
        />
        const FooterPageBlock = <Pagination
            label={footerContentText}
            hasPrevious={blHasPrevious && !tableTabsLoading}
            onPrevious={() => this.changeTablePage(page - 1)}
            hasNext={blHasNext && !tableTabsLoading}
            onNext={() => this.changeTablePage(page + 1)}
        />

        // fix进度
        const FixingTagProgress = (isShowFixTagProgress !== -1 && isShowFixTagProgress === tabKey) && <div className='opt_fixtag_progress Every_Card_Space_Hale'>
            <BlockStack gap={200}>
                <div className='fixtag_top flex_layout'>
                    <div className='fixtag_top_loading'>
                        <Text variant="headingSm" as="h6">{(checkState && optType === 1) ? t("Auto fixing") : current_operation === 1 ? t("Redirecting") : current_operation === 2 ? t("Ignoring") : t("Optimizing")}</Text>
                        <Spinner size='small' />
                        {
                            Boolean((current_operation === 1 || current_operation === 2) && optType !== 1) && <Button variant='plain' loading={stopBatchOptLoading} onClick={() => this.stopBatchOpt(tabKey)}>{t("Stop Now")}</Button>
                        }
                    </div>

                    <Text as="p" color="subdued">{t("completed /all")} : {current_implement_number} /{implement_number}</Text>
                </div>
                {implement_number !== 0 && <div className='fixtag_bottom'>
                    <ProgressBar progress={Math.ceil((current_implement_number / implement_number) * 100)} size="small" tone="success" />
                </div>}
            </BlockStack>
        </div>

        // 常见问题
        const FrequentlyItems = <FaqCardBox FaqList={questionList} />

        // 页面内容
        const pageContentMain = <div className='Brokenlinks_main'>
            <BlockStack gap={400}>
                <Card>
                    <BlockStack gap={200}>
                        <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                            <div className='flex_layout'>
                                <Text variant="headingMd" as="h2">{t("Auto fix broken links")}</Text>
                                <Badge tone={checkState ? 'success' : ''}>{checkState ? t("On") : t("Off")}</Badge>
                                {
                                    level === 1 ? <PlanLockBlock plan={1} upgradeShow={this.upgradeShow} /> : null
                                }
                            </div>
                            <div className='flex_layout'>
                                {Boolean(switchLoading) && <img className="Loading" src="/imgs/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                <Switch disabled={!Boolean(targetLink) || Boolean(saveLoading) || Boolean(switchLoading)} onChange={() => this.updAutoRedirectState('switch')} checked={checkState} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                            </div>
                        </div>
                        <div className='blink_top flex_layout'>
                            <Text as="p" tone="subdued">
                                {t("Activate this feature. SEOWILL will automatically redirect newly detected 404 links to")}
                            </Text>
                            <div className='b_target_link'>
                                {
                                    targetLink && targetLink.includes('http') ? <span onClick={() => {
                                        window.open(targetLink)
                                    }}>{targetLink}</span> : <span onClick={() => {
                                        window.open(`https://${domain}${targetLink[0] !== '/' ? '/' + targetLink : targetLink}`)
                                    }}>{domain}{targetLink}</span>
                                }
                                <span onClick={this.openTargetEdit}><Icon source={EditIcon} tone='base' /></span>
                            </div>
                        </div>
                    </BlockStack>
                </Card>
                <Card padding={0}>
                    <TableFilters
                        loading={loading || tableTabsLoading}
                        itemStrings={[
                            t("Unresolved 404 errors"),
                            t("Manage Redirects"),
                            t("Ignored 404 errors"),
                        ]}
                        queryValue={queryValue}
                        setSelectedTabsIndex={(e) => this.handleTypeTabsChange(e)}
                        setQueryValue={(v) => this.setQueryValue(v)}
                    />
                    {FixingTagProgress}
                    {/* {tableTabsLoading ? <div className='flex_layout table_loading'>
                        <Spinner />
                    </div> : */}
                    <IndexTableBox
                        loading={tableTabsLoading}
                        tabKey={tabKey}
                        domain={domain}
                        headings={tabKey === 1 ? manageHeading : tabKey === 2 ? ignoredHeading : unresolvedHeading}
                        dataList={tableData}
                        checkState={checkState}
                        total={total}
                        obj_name={'links'}
                        setChangeInputVal={this.setChangeInputVal}
                        onBlurUpdateSeo={this.onBlurUpdateSeo}
                        updateTableIgnore={this.updateTableIgnore}
                        getTableItemState={this.getTableItemState}
                        deleteBrokenLink={this.deleteBrokenLink}
                        promotedBulkActions={promotedBulkActions}
                    />
                    {/* } */}
                    {tableData.length > 0 && <div className="justify_center sticky_footer">
                        {FooterPageBlock}
                    </div>}
                </Card>
            </BlockStack>
        </div>

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终内容
        const pageContentLast = loadingPage ? <SkeltonLoading /> :
            <Page
            // title={
            // <div style={{ display: "flex", alignItems: "center" }}>
            //     {t("Broken Links")}&nbsp;
            // </div>
            // }
            // backAction={{
            //     content: t("Broken Links"), 
            //     onAction: this.goBack,
            //   }}
            // primaryAction={(tabKey === 2) ? false : {
            //     content: t("Create a Redirect"),
            //     onAction: () => this.operaCreateModal(true)
            // }}
            // actionGroups={(tabKey === 2) ? [] : [
            //     {
            //         title: t("Actions"),
            //         actions: [
            //             {
            //                 content: t("Import"),
            //                 accessibilityLabel: "Import",
            //                 onAction: () => this.handleObjState("ImportActive", true),
            //                 icon: ExportMinor
            //             },
            //             {
            //                 content: t("Export"),
            //                 accessibilityLabel: "Export",
            //                 onAction: () => this.handleObjState("ExportActive", true),
            //                 icon: ImportMinor
            //             },
            //         ],
            //     }
            // ]}
            >
                <title>SEOWILL - Broken Link Redirects</title>
                {tipBannerPwd}
                <div className='pageButton flex_layout'>
                    <Popover
                        active={actionState}
                        activator={
                            level === 1 ? <Button onClick={this.toggleActions} disabled icon={LockIcon}>{t("Actions")}</Button> : <Button onClick={this.toggleActions} disclosure>{t("Actions")}</Button>
                        }
                        onClose={this.toggleActions}
                    >
                        <ActionList
                            actionRole="menuitem"
                            items={[
                                {
                                    content: t("Import"),
                                    accessibilityLabel: "Import",
                                    onAction: () => this.handleObjState("ImportActive", true),
                                    icon: ExportIcon
                                },
                                {
                                    content: t("Export"),
                                    accessibilityLabel: "Export",
                                    onAction: () => this.handleObjState("ExportActive", true),
                                    icon: ImportIcon
                                },
                            ]}
                        />
                    </Popover>
                    <Button variant='primary' onClick={() => this.operaCreateModal(true)}>{t("Create a Redirect")}</Button>
                </div>
                <BlockStack gap={400}>
                    {pageContentMain}
                    {FrequentlyItems}
                </BlockStack>

                {createModal}
                {bulkRedirectModal}
                {bulkIgnoreModal}
                {unignoreModal}
                {deleteModal}
                {targetEditModal}
                {/* 底部 */}
                {FooterHelpBox}
            </Page>

        return (
            <div className="Brokenlink_Page">
                {pageContentLast}

                {/* 好评弹窗 */}
                {/* <NewReviewModal open={IsPop} changeData={() => this.handleObjState('IsPop', false)} content={<span>{t("The broken links was redirected successfully")}</span>} reRequest={this.ChildrenReRequest} modalEmail={modalEmail} modalName={modalName} modalDefaultEmail={modalName} /> */}

                {/**单个导入 */}
                <AddRedirectActionModal AddRedirectActive={AddRedirectActive} domain={domain} toggleToast={this.props.toggleToast} handleChangeAddRedirect={this.handleChangeAddRedirect} />
                {/**批量导入 */}
                <ImportRedirectActionModal level={level} openUpgradeModelShow={this.openUpgradeModal} ImportActive={ImportActive} CloseImport={() => this.handleObjState('ImportActive', false)} toggleToast={this.props.toggleToast} />
                {/**批量导出 */}
                <ExportRedirectActionModal level={level} openUpgradeModelShow={this.openUpgradeModal} ExportActive={ExportActive} CloseExport={() => this.handleObjState('ExportActive', false)} toggleToast={this.props.toggleToast} />
                {/* 升级 */}
                {/* <UpgradeModalV2 upgradeModalShow={upgradeModalShow} closeUpgradeModelV2={this.closeUpgradeModelV2} /> */}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['Brokenlinks', data]));
    },
})

BrokenLinkPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(BrokenLinkPage);

export default withRouter(BrokenLinkPage);
